import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

export enum TypeButton {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    DELINEADO = 'outlined',
    LINK = 'link',
}

export enum ButtonSize {
    SM = 'small',
    MD = 'medium',
    LG = 'large'
}

@Component({
    selector: 'dian-button',
    templateUrl: './button.component.html',
    styleUrl: './button.component.scss',
    imports: [NgIf],
    standalone: true,
})
export class ButtonComponent {
    @Input() type: string = TypeButton.PRIMARY;
    @Input() disabled: boolean = false;
    @Input() label = 'Button';
    @Input() iconLeft!: string;
    @Input() iconRight!: string;
    @Input() hasError = false;
    @Input() size: ButtonSize = ButtonSize.MD
    @Output() clicked = new EventEmitter<boolean>();

    typeButton = TypeButton;

    onClick(): void {
        this.clicked.emit(true);
    }
}
